export const oktaAuthConfig = {
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '',
  issuer: process.env.REACT_APP_OKTA_BASE_URL || '',
  redirectUri: process.env.REACT_APP_OKTA_REDIRECTURI || '',
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true,
};

export const novaDreamMapConfig = {
  token: process.env.REACT_APP_API_TOKEN,
  urlBase: process.env.REACT_APP_API_URL,
  Name: 'Nova Dream',
  Version: 'Version 2.0.3 Prof - 02/07/2025',
  urlAmplify: process.env.REACT_APP_URL_AMPLYFY
};

